import React from 'react';

const LogoFull = () => (
  <img
    src="/Logo-02.png"
    alt="Cubeangle"
    style={{ height: 40, width: 'auto', objectFit: 'contain' }}
  />
);

export default LogoFull;
